import { useQuery } from '@apollo/client';
import { useMemo } from 'react';
import { gql } from '../graphql/generated/gql';

export const USER_MEMBERSHIP_TOPICS = gql(`
  query userMembershipTopics($userId: ID!) {
    user(id: $userId) {
      id
      membershipTopics(includeGroups: true) {
        id
        name
      }
    }
  }
`);

export const useUserMembershipTopics = ({ userId }: { userId: string }) => {
  const { data } = useQuery(USER_MEMBERSHIP_TOPICS, { variables: { userId } });

  return useMemo(() => data?.user?.membershipTopics ?? [], [data]);
};
